export default {
    state: () => document.visibilityState ||
        document.webkitVisibilityState ||
        document.mozVisibilityState ||
        document.msVisibilityState,
    changeEvent: getChangeEvent(),
};
function getChangeEvent() {
    if (document.visibilityState) {
        return 'visibilitychange';
    }
    else if (document.webkitVisibilityState) {
        return 'webkitvisibilitychange';
    }
    else if (document.mozVisibilityState) {
        return 'mozvisibilitychange';
    }
    else if (document.msVisibilityState) {
        return 'msvisibilitychange';
    }
    return undefined;
}
